import axios from "axios";
import { adminMainUrl } from "../../../../Config";



//ff -> air -> export -> get query info by quotation
export const getPackageInfoByQuotation = (token, user_id, quotation_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_QUERY_INFO_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const body = { quotation_id: quotation_id }

        const apiUrl = `${adminMainUrl}/api/freight/forwarding/get-query-info-by-quotation-id`;
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_FF_QUERY_INFO_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getPackageInfoByQuotation function (redux):", err);
                dispatch({
                    type: "FIND_FF_QUERY_INFO_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getPackageInfoByQuotation function:", error);
            dispatch({
                type: "FIND_FF_QUERY_INFO_FAILURE",
                payload: error,
            });
        }
    };
};


//ff -> air -> export -> job order
export const getFFAirImpJobOrder = (token, user_id, trans_mode = "Air", trans_type = "import") => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_AIR_IMP_JOBORDER_REQUEST",
        });

        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        const apiUrl = `${adminMainUrl}/api/freight/forwarding/air/import/joborderlist?trans_mode=${trans_mode}&trans_type=${trans_type}`;
        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_FF_AIR_IMP_JOBORDER_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFAirImpJobOrder function (redux):", err);
                dispatch({
                    type: "FIND_FF_AIR_IMP_JOBORDER_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFAirImpJobOrder function:", error);
            dispatch({
                type: "FIND_FF_AIR_IMP_JOBORDER_FAILURE",
                payload: error,
            });
        }
    };
};

//ff -> air -> export -> final Quotation 
export const getFFAirImpFinalQuotation = (token, user_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_AIR_IMP_FINAL_QUOTATION_REQUEST",
        });

        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/freight/forwarding/air/import/final-quotation-list`;
        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_FF_AIR_IMP_FINAL_QUOTATION_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFAirImpFinalQuotation function (redux):", err);
                dispatch({
                    type: "FIND_FF_AIR_IMP_FINAL_QUOTATION_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFAirImpFinalQuotation function:", error);
            dispatch({
                type: "FIND_FF_AIR_IMP_FINAL_QUOTATION_FAILURE",
                payload: error,
            });
        }
    };
};

//ff -> air -> export -> currency 
export const getFFAirImpCurrency = (token, user_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_AIR_IMP_CURRENCY_REQUEST",
        });

        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/currency/list`;
        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_FF_AIR_IMP_CURRENCY_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFAirImpCurrency function (redux):", err);
                dispatch({
                    type: "FIND_FF_AIR_IMP_CURRENCY_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFAirImpCurrency function:", error);
            dispatch({
                type: "FIND_FF_AIR_IMP_CURRENCY_FAILURE",
                payload: error,
            });
        }
    };
};

//ff -> air -> export -> Airport 
export const getFFAirImpAirport = (token, user_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_AIR_IMP_AIRPORT_REQUEST",
        });

        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/airport/list`;
        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_FF_AIR_IMP_AIRPORT_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFAirImpAirport function (redux):", err);
                dispatch({
                    type: "FIND_FF_AIR_IMP_AIRPORT_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFAirImpAirport function:", error);
            dispatch({
                type: "FIND_FF_AIR_IMP_AIRPORT_FAILURE",
                payload: error,
            });
        }
    };
};

//ff -> air -> export -> Organisation 
export const getFFAirImpOrganisation = (token, user_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_AIR_IMP_ORGANISATION_REQUEST",
        });

        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/freight/forwarding/air/import/organisation-list`;
        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_FF_AIR_IMP_ORGANISATION_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFAirImpOrganisation function (redux):", err);
                dispatch({
                    type: "FIND_FF_AIR_IMP_ORGANISATION_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFAirImpOrganisation function:", error);
            dispatch({
                type: "FIND_FF_AIR_IMP_ORGANISATION_FAILURE",
                payload: error,
            });
        }
    };
};

//ff -> air -> export -> mawb -> unused hawb List 
export const getFFAirImpUnusedHAWBList = (token, user_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_AIR_IMP_UNUSED_HAWB_REQUEST",
        });

        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/freight/forwarding/air/import/get-unused-hawb-list`;
        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_FF_AIR_IMP_UNUSED_HAWB_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFAirImpUnusedHAWBList function (redux):", err);
                dispatch({
                    type: "FIND_FF_AIR_IMP_UNUSED_HAWB_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFAirImpUnusedHAWBList function:", error);
            dispatch({
                type: "FIND_FF_AIR_IMP_UNUSED_HAWB_FAILURE",
                payload: error,
            });
        }
    };
};

//ff -> air -> export -> mawb -> unused hawb List  update
export const getFFAirImpUnusedHAWBUpdateList = (token, user_id, mawb_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_AIR_IMP_UNUSED_HAWB_UPDATE_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/freight/forwarding/air/import/get-all-hawb-list`;
        let body = { id: mawb_id }
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_FF_AIR_IMP_UNUSED_HAWB_UPDATE_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFAirImpUnusedHAWBUpdateList function (redux):", err);
                dispatch({
                    type: "FIND_FF_AIR_IMP_UNUSED_HAWB_UPDATE_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFAirImpUnusedHAWBUpdateList function:", error);
            dispatch({
                type: "FIND_FF_AIR_IMP_UNUSED_HAWB_UPDATE_FAILURE",
                payload: error,
            });
        }
    };
};

//ff -> air -> export -> hawbb details 
export const getFFAirImportHAWBDetail = (token, user_id, hawb_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_AIR_IMP_HAWB_DETAIL_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/freight/forwarding/air/import/hawb/view`;
        let body = { id: hawb_id }
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_FF_AIR_IMP_HAWB_DETAIL_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFAirImportHAWBDetail function (redux):", err);
                dispatch({
                    type: "FIND_FF_AIR_IMP_HAWB_DETAIL_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFAirImportHAWBDetail function:", error);
            dispatch({
                type: "FIND_FF_AIR_IMP_HAWB_DETAIL_FAILURE",
                payload: error,
            });
        }
    };
};

//ff -> air -> export -> direct MAWB details 
export const getFFAirImporDirectMAWBDetail = (token, user_id, hawb_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_AIR_IMP_DIRECT_MAWB_DETAIL_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/freight/forwarding/air/import/direct-shipment/mawb/view`;
        let body = { id: hawb_id }
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_FF_AIR_IMP_DIRECT_MAWB_DETAIL_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFAirImporDirectMAWBDetail function (redux):", err);
                dispatch({
                    type: "FIND_FF_AIR_IMP_DIRECT_MAWB_DETAIL_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFAirImporDirectMAWBDetail function:", error);
            dispatch({
                type: "FIND_FF_AIR_IMP_DIRECT_MAWB_DETAIL_FAILURE",
                payload: error,
            });
        }
    };
};

//ff -> air -> export -> mawb details 
export const getFFAirImportMAWBDetail = (token, user_id, mawb_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_AIR_IMP_MAWB_DETAIL_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/freight/forwarding/air/import/mawb/view`;
        let body = { id: mawb_id }
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_FF_AIR_IMP_MAWB_DETAIL_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFAirImportMAWBDetail function (redux):", err);
                dispatch({
                    type: "FIND_FF_AIR_IMP_MAWB_DETAIL_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFAirImportMAWBDetail function:", error);
            dispatch({
                type: "FIND_FF_AIR_IMP_MAWB_DETAIL_FAILURE",
                payload: error,
            });
        }
    };
};

//ff -> air -> export -> shipper organisation -> branch list 
export const getFFAirImpShipperBranch = (token, user_id, organisation_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_AIR_IMP_SHIPPER_BRANCH_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const body = { organisation_id: organisation_id }

        const apiUrl = `${adminMainUrl}/api/freight/forwarding/air/import/organisation-branch-list`;
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_FF_AIR_IMP_SHIPPER_BRANCH_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFAirImpShipperBranch function (redux):", err);
                dispatch({
                    type: "FIND_FF_AIR_IMP_SHIPPER_BRANCH_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFAirImpShipperBranch function:", error);
            dispatch({
                type: "FIND_FF_AIR_IMP_SHIPPER_BRANCH_FAILURE",
                payload: error,
            });
        }
    };
};

//ff -> air -> export -> shipper organisation -> branch list 
export const getFFAirImpConsigneeBranch = (token, user_id, organisation_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_AIR_IMP_CONSIGNEE_BRANCH_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const body = { organisation_id: organisation_id }

        const apiUrl = `${adminMainUrl}/api/freight/forwarding/air/import/organisation-branch-list`;
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_FF_AIR_IMP_CONSIGNEE_BRANCH_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFAirImpConsigneeBranch function (redux):", err);
                dispatch({
                    type: "FIND_FF_AIR_IMP_CONSIGNEE_BRANCH_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFAirImpConsigneeBranch function:", error);
            dispatch({
                type: "FIND_FF_AIR_IMP_CONSIGNEE_BRANCH_FAILURE",
                payload: error,
            });
        }
    };
};

//ff -> air -> export ->  shipper -> organisation -> branch list -> Bank account list
export const getFFAirImpShipperBranchBank = (token, user_id, branch_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_AIR_IMP_SHIPPER_BRANCH_BANK_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        let body = { branch_id: branch_id }

        const apiUrl = `${adminMainUrl}/api/freight/forwarding/air/import/branch-bank-list`;
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_FF_AIR_IMP_SHIPPER_BRANCH_BANK_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFAirImpShipperBranchBank function (redux):", err);
                dispatch({
                    type: "FIND_FF_AIR_IMP_SHIPPER_BRANCH_BANK_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFAirImpShipperBranchBank function:", error);
            dispatch({
                type: "FIND_FF_AIR_IMP_SHIPPER_BRANCH_BANK_FAILURE",
                payload: error,
            });
        }
    };
};

//ff -> air -> export -> consignee -> organisation -> branch list -> Bank account list
export const getFFAirImpConsigneeBranchBank = (token, user_id, branch_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_AIR_IMP_CONSIGNEE_BRANCH_BANK_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        let body = { branch_id: branch_id }

        const apiUrl = `${adminMainUrl}/api/freight/forwarding/air/import/branch-bank-list`;
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_FF_AIR_IMP_CONSIGNEE_BRANCH_BANK_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFAirImpConsigneeBranchBank function (redux):", err);
                dispatch({
                    type: "FIND_FF_AIR_IMP_CONSIGNEE_BRANCH_BANK_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFAirImpConsigneeBranchBank function:", error);
            dispatch({
                type: "FIND_FF_AIR_IMP_CONSIGNEE_BRANCH_BANK_FAILURE",
                payload: error,
            });
        }
    };
};

//ff -> air -> export -> console shipment List
export const getFFAirImportConsoleShipmentList = (token, user_id, page_no, ship_status, queryString = "") => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_AIR_IMP_CONSOLE_SHIPMENT_LIST_REQUEST",
        });

        let config = {
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let baseUrl;
        if (ship_status == "HAWB") {
            baseUrl = `${adminMainUrl}/api/freight/forwarding/air/import/hawb/list`;
        } else if (ship_status == "MAWB") {
            baseUrl = `${adminMainUrl}/api/freight/forwarding/air/import/mawb/list`;
        } else {
            throw new Error("Invalid ship status.");
        }

        let queryArr = [];
        if (page_no) queryArr.push(`page=${page_no}`);
        if (queryString) queryArr.push(queryString);
        let apiUrl = baseUrl + (queryArr.length > 0 ? `?${queryArr.join('&')}` : '');

        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_FF_AIR_IMP_CONSOLE_SHIPMENT_LIST_SUCCESS",
                    payload: res?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFAirImportConsoleShipmentList function (redux):", err);
                dispatch({
                    type: "FIND_FF_AIR_IMP_CONSOLE_SHIPMENT_LIST_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFAirImportConsoleShipmentList function:", error);
            dispatch({
                type: "FIND_FF_AIR_IMP_CONSOLE_SHIPMENT_LIST_FAILURE",
                payload: error,
            });
        }
    };
};

//ff -> air -> export -> direct shipment List
export const getFFAirImportDirectShipmentList = (token, user_id, page_no, queryString = "") => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_AIR_IMP_DIRECT_SHIPMENT_LIST_REQUEST",
        });

        let config = {
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let baseUrl = `${adminMainUrl}/api/freight/forwarding/air/import/direct-shipment/mawb/list`;
        let queryArr = [];
        if (page_no) queryArr.push(`page=${page_no}`);
        if (queryString) queryArr.push(queryString);
        let apiUrl = baseUrl + (queryArr.length > 0 ? `?${queryArr.join('&')}` : '');

        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_FF_AIR_IMP_DIRECT_SHIPMENT_LIST_SUCCESS",
                    payload: res?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFAirImportDirectShipmentList function (redux):", err);
                dispatch({
                    type: "FIND_FF_AIR_IMP_DIRECT_SHIPMENT_LIST_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFAirImportDirectShipmentList function:", error);
            dispatch({
                type: "FIND_FF_AIR_IMP_DIRECT_SHIPMENT_LIST_FAILURE",
                payload: error,
            });
        }
    };
};

//ff -> air -> export -> console manifest List
export const getFFAirImportConsoleManifestList = (token, user_id, page_no, queryString = "") => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_AIR_IMP_CONSOLE_MANIFEST_LIST_REQUEST",
        });

        let config = {
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let baseUrl = `${adminMainUrl}/api/freight/forwarding/air/import/console-manifest/list`;
        let queryArr = [];
        if (page_no) queryArr.push(`page=${page_no}`);
        if (queryString) queryArr.push(queryString);
        let apiUrl = baseUrl + (queryArr.length > 0 ? `?${queryArr.join('&')}` : '');

        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_FF_AIR_IMP_CONSOLE_MANIFEST_LIST_SUCCESS",
                    payload: res?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFAirImportConsoleManifestList function (redux):", err);
                dispatch({
                    type: "FIND_FF_AIR_IMP_CONSOLE_MANIFEST_LIST_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFAirImportConsoleManifestList function:", error);
            dispatch({
                type: "FIND_FF_AIR_IMP_CONSOLE_MANIFEST_LIST_FAILURE",
                payload: error,
            });
        }
    };
};

//ff -> air -> export -> unused mawb in console manifest add form
export const getFFAirImportConsoleManifestMAWBAddList = (token, user_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_AIR_IMP_CONSOLE_MANIFEST_MAWB_ADD_LIST_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/freight/forwarding/air/import/console-manifest/unused-mawb-add-list`;
        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_FF_AIR_IMP_CONSOLE_MANIFEST_MAWB_ADD_LIST_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFAirImportConsoleManifestMAWBAddList function (redux):", err);
                dispatch({
                    type: "FIND_FF_AIR_IMP_CONSOLE_MANIFEST_MAWB_ADD_LIST_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFAirImportConsoleManifestMAWBAddList function:", error);
            dispatch({
                type: "FIND_FF_AIR_IMP_CONSOLE_MANIFEST_MAWB_ADD_LIST_FAILURE",
                payload: error,
            });
        }
    };
};

// //ff -> air -> export -> unused mawb in console manifest edit form
// export const getFFAirImportConsoleManifestMAWBEditList = (token, user_id, console_manifest_id) => {
//     return async function (dispatch) {
//         dispatch({
//             type: "FIND_FF_AIR_IMP_CONSOLE_MANIFEST_MAWB_EDIT_LIST_REQUEST",
//         });

//         let config = {
//             // method: "GET",
//             headers: {
//                 'auth-token': token,
//                 'user_id': user_id,
//                 'Content-Type': 'application/json',
//             }
//         };
//         let apiUrl = `${adminMainUrl}/api/freight/forwarding/air/import/console-manifest/unused-mawb-add-list`;
//         let body = { id: console_manifest_id }
//         try {
//             axios.post(apiUrl, body, config).then((res) => {
//                 dispatch({
//                     type: "FIND_FF_AIR_IMP_CONSOLE_MANIFEST_MAWB_EDIT_LIST_SUCCESS",
//                     payload: res?.data?.data,
//                 });
//             }).catch((err) => {
//                 console.log("ERROR in getFFAirImportConsoleManifestMAWBEditList function (redux):", err);
//                 dispatch({
//                     type: "FIND_FF_AIR_IMP_CONSOLE_MANIFEST_MAWB_EDIT_LIST_FAILURE",
//                     payload: err,
//                 });
//             });
//         } catch (error) {
//             console.log("Unexpected error in getFFAirImportConsoleManifestMAWBEditList function:", error);
//             dispatch({
//                 type: "FIND_FF_AIR_IMP_CONSOLE_MANIFEST_MAWB_EDIT_LIST_FAILURE",
//                 payload: error,
//             });
//         }
//     };
// };


//calcualte toatl freight in mawb
//ff -> air -> export -> unused mawb in console manifest add form
export const calculateTotalFreightMAWB = (token, user_id, hawb_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_CALCULATE_TOTAL_FREIGHT_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/freight/forwarding/air/import/mawb/calculate-hawb-no`;
        let body = { hawb_id_arr: hawb_id }
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_CALCULATE_TOTAL_FREIGHT_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in calculateTotalFreightMAWB function (redux):", err);
                dispatch({
                    type: "FIND_CALCULATE_TOTAL_FREIGHT_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in calculateTotalFreightMAWB function:", error);
            dispatch({
                type: "FIND_CALCULATE_TOTAL_FREIGHT_FAILURE",
                payload: error,
            });
        }
    };
};